import PropTypes from 'prop-types';
import loadingImg from 'assets/img/loading.png';
import { Button, ButtonChildren, LoadingStyled, PrependIcon } from './styled';

RButton.propTypes = {
  variant: PropTypes.string,
  fullWidth: PropTypes.bool,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  prependIcon: PropTypes.any,
  type: PropTypes.string,
  variantColor: PropTypes.string,
  height: PropTypes.number,
  form: PropTypes.string,
  children: PropTypes.any,
  onClick: PropTypes.func,
  css: PropTypes.any,
  innerRef: PropTypes.any,
};

export function RButton({
  type = 'button',
  variant,
  variantColor,
  prependIcon,
  fullWidth,
  name,
  height = 46,
  disabled = false,
  loading = false,
  onClick = () => {},
  children,
  css,
  form,
  innerRef,
  ...rest
}) {
  return (
    <Button
      type={type}
      variant={variant}
      variantColor={variantColor}
      fullWidth={fullWidth}
      height={height}
      disabled={disabled}
      onClick={disabled || loading ? null : onClick}
      css={css}
      form={form}
      ref={innerRef}
      name={name}
      {...rest}
    >
      <ButtonChildren>
        <>
          {prependIcon && (
            <PrependIcon disabled={disabled}>{prependIcon}</PrependIcon>
          )}
          {children}
          {loading && (
            <LoadingStyled
              src={loadingImg}
              alt="loading"
            />
          )}
        </>
      </ButtonChildren>
    </Button>
  );
}
